import { useState, useCallback, useEffect } from "react";
import { message } from "antd";
import type { GetKycQuestionnairesQuery } from "../../graphql";
import sdk from "../../sdk";

export const useKycQuestionnaires = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<GetKycQuestionnairesQuery>();
  const [page, setPage] = useState(0);
  const [limit] = useState(20);

  const getKycQuestionnaires = useCallback(() => {
    setLoading(true);
    sdk
      .getKycQuestionnaires({ page, limit })
      .then((data) => setData(data))
      .catch((err) => {
        message.warn(err.response?.errors[0]?.message, 2);
      })
      .finally(() => setLoading(false));
  }, [page, limit]);

  const deleteKycQuestionnaire = (id: string) => {
    setLoading(true);
    sdk
      .deleteKycQuestionnaire({ _id: id })
      .then(() => {
        message.success("Амжилттай устгагдлаа");
        getKycQuestionnaires();
      })
      .catch((err) => {
        message.warn(err.response?.errors[0]?.message, 2);
      })
      .finally(() => setLoading(false));
  };

  const toggleActive = (id: string, active: boolean) => {
    setLoading(true);
    sdk
      .editKycQuestionnaire({ _id: id, input: { active } })
      .then(() => {
        message.success(
          active ? "Идэвхтэй болголоо" : "Идэвхгүй болголоо"
        );
        getKycQuestionnaires();
      })
      .catch((err) => {
        message.warn(err.response?.errors[0]?.message, 2);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getKycQuestionnaires();
  }, [getKycQuestionnaires]);

  return {
    data: data?.getKycQuestionnaires,
    loading,
    page,
    setPage,
    getKycQuestionnaires,
    deleteKycQuestionnaire,
    toggleActive,
  };
};
